import React from 'react';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {
  AppBar,
  Dialog,
  DialogProps,
  IconButton,
  Slide,
  Toolbar,
  Tooltip,
  Typography,
} from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface Props extends DialogProps {
  url: string;
  title?: string;
}

export const UrlDialog: React.FC<Props> = ({ url, title, ...props }) => {
  const handleClose = () => props?.onClose?.({}, 'escapeKeyDown');

  return (
    // @ts-ignore
    <Dialog fullScreen TransitionComponent={Transition} {...props}>
      <AppBar sx={{ position: 'relative' }} elevation={0}>
        <Toolbar>
          <Tooltip title="Voltar">
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
              sx={{ color: 'white' }}
            >
              <ArrowBackIcon />
            </IconButton>
          </Tooltip>

          <Typography
            sx={{ ml: 2, flex: 1, color: 'white' }}
            variant="h6"
            component="div"
          >
            {title}
          </Typography>
        </Toolbar>
      </AppBar>

      <iframe src={url} title={title || ''} style={{ height: '100%' }} />
    </Dialog>
  );
};

